export default __webpack_public_path__ + "static/media/Winter tree1.dc285ec8.jpg";